import ComponentWithSocket from '../../../lib/component'
import { Component } from 'vue-property-decorator';

import * as Store from '../../../store';

import template from './add.vue';

import moment from 'moment';

// Websockets
import { WebsocketsListener } from '../../../utils/ws';

@Component({
    mixins: [template]
})

export default class AuctionsAdd extends ComponentWithSocket {

    private name: string = ''
    private description: string = ''
    private startDate: string = ''
    private startTime: string = ''
    private websiteId: string = ''

    constructor() {

        super();

    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from)
        next()
    }

    mounted() {

        // Assign session values to store for global dispatch
        this.wsListener.onPost('admin.auctions', (success: boolean, data: any) => {

            if (success) {
                this.$router.push('/auctions')
            }
            else {
                alert(data)
            }

        })

    }

    addAuction() {

        let startDate

        if (this.startDate && this.startTime) {
            startDate = moment.utc(this.startDate + ' ' + this.startTime, 'DD-MM-YYYY HH:mm')
        }

        let auctionData = {
            name: this.name,
            description: this.description,
            startDate: startDate ? startDate.toDate() : undefined,
            websiteId: this.websiteId
        }

        this.wsListener.sendPost('admin.auctions', auctionData)

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/auctions/add/index.ts